var map = {
	"./QR-public.png": "fdcc",
	"./avatar.png": "0gU3",
	"./b2b_logo.png": "LYJv",
	"./b2b_logo_.png": "6lNM",
	"./b2b_logo_white.png": "XrSU",
	"./b2c/b2c_c_1.png": "Yq7w",
	"./b2c/b2c_c_10.png": "2ZHt",
	"./b2c/b2c_c_2.png": "Ensq",
	"./b2c/b2c_c_3.png": "IG6A",
	"./b2c/b2c_c_4.png": "l9U8",
	"./b2c/b2c_c_5.png": "MfNl",
	"./b2c/b2c_c_6.png": "/BX6",
	"./b2c/b2c_c_7.png": "w2/F",
	"./b2c/b2c_c_8.png": "3lyc",
	"./b2c/b2c_c_9.png": "W+8V",
	"./b2c/b2c_main_logo.png": "Owc6",
	"./b2c/banner_1.png": "EVxq",
	"./b2c/cart.png": "/oMT",
	"./b2c/dianpu.png": "hAmq",
	"./b2c/jifen.png": "Eg+b",
	"./b2c/kabi_icon.png": "Vkry",
	"./b2c/kabi_quanyi.png": "ftiI",
	"./b2c/kefu.png": "bMHC",
	"./b2c/shan_icon.png": "0TKq",
	"./b2c/tuijian.png": "IS1O",
	"./b2c/xinpin.png": "qZKP",
	"./banner.png": "P07D",
	"./banner_.png": "fdMV",
	"./beijing.png": "TP5V",
	"./businessLicense.png": "TK+b",
	"./buyNumber.png": "HHND",
	"./buy_help.png": "sPCo",
	"./buy_help1.png": "5NQh",
	"./cereshop/home/chakan.png": "er5V",
	"./cereshop/home/logo.png": "Wt6R",
	"./cereshop/home/logo_.png": "hx4M",
	"./cereshop/home/main_logo.png": "yy6E",
	"./cereshop/home/main_logo_white.png": "EFYr",
	"./cereshop/home/quanb.png": "ufdN",
	"./coupon/card-side-blue.png": "ZYW+",
	"./coupon/card-side-blue2.png": "a9Zm",
	"./coupon/card-side-green.png": "I8Oy",
	"./coupon/card-side-green2.png": "X94k",
	"./coupon/card-side-grey.png": "JjAb",
	"./coupon/card-side-grey2.png": "+ISI",
	"./coupon/card-side-pink.png": "LXVM",
	"./coupon/card-side-pink2.png": "f0Xi",
	"./coupon/card-side-red.png": "A/j8",
	"./coupon/card-side-red2.png": "YW7V",
	"./dainzhuwechat.png": "kaYh",
	"./dealNumber.png": "n+VG",
	"./defaultHeadImg.png": "0wEb",
	"./diamond.png": "jxsv",
	"./dingwei.png": "Jpuh",
	"./ditu.png": "FDyP",
	"./dlogo.png": "LwjX",
	"./dlogo_.png": "ofr4",
	"./dlogo_white.png": "0R5p",
	"./dyou.png": "ByPx",
	"./dz-banner-.png": "2Ku4",
	"./dz-banner.png": "WIzy",
	"./dz-banner_.png": "mXJt",
	"./dzuo.png": "OvBr",
	"./edit.png": "KObk",
	"./erweima.png": "hMRt",
	"./favorablePrice.png": "U0XH",
	"./finish.png": "9SDd",
	"./finish2.png": "a7zt",
	"./fire.png": "gfE7",
	"./fu_zhuang_fu_shi.png": "7ybh",
	"./fu_zhuang_fu_shi_.png": "jtzJ",
	"./gift.png": "3K0C",
	"./header-backImg.png": "2gkV",
	"./icon-Agricultural-special-products.png": "TRlD",
	"./icon-Bulk-grain-and-oil.png": "U65v",
	"./icon-Intellectual-property.png": "80H9",
	"./icon-Intercollegiate-business-circle.png": "Tyur",
	"./icon-Livestock-industry.png": "V03J",
	"./icon-Mineral-resources.png": "CdT9",
	"./icon-The-government-acquisition.png": "HTpH",
	"./icon-Wisdom-site.png": "IgvY",
	"./idCardBack.png": "xhXB",
	"./idCardFront.png": "rIYu",
	"./imgPay.png": "LFuk",
	"./indexBg.png": "L9L/",
	"./indexBg2.png": "0fI+",
	"./indexBgBig.png": "iNFA",
	"./indexLogo.png": "L6Q4",
	"./jiantou.png": "gEds",
	"./jufutong.png": "9n39",
	"./login-banner.png": "cCGQ",
	"./loginShop@2x.png": "1geE",
	"./logo.png": "iQH9",
	"./money-line.png": "vhvE",
	"./noEdit.png": "U8Wl",
	"./noStore.png": "xHf+",
	"./offline_pay.png": "a6Iu",
	"./offline_pay_small_info.png": "Lpqx",
	"./online_credit_pay.png": "vRLT",
	"./online_help.png": "jBFP",
	"./online_pay.png": "DzVY",
	"./orderPrice.png": "uGJ3",
	"./orderTotal.png": "Q6rM",
	"./payment@2x.png": "LttV",
	"./qinchu_banner.png": "c+qb",
	"./qiye.png": "49iJ",
	"./qiyerenzheng.png": "OB2f",
	"./qrcode.png": "/4D4",
	"./qrcode2.png": "+rBk",
	"./renzheng.png": "tDVS",
	"./rou_lei_dan_bai.png": "3JND",
	"./rou_lei_dan_bai_.png": "Y8Zb",
	"./ruzhuBanner.png": "hElM",
	"./ruzhuJiantou.png": "jORw",
	"./ruzhuLogo.png": "JvA7",
	"./setUpShop@2x.png": "okOl",
	"./settledPlatform.png": "cmt+",
	"./settledPlatform_.png": "Cte5",
	"./shenqinrenhzeng.png": "rZU2",
	"./shi_pin_bai_huo.png": "G7R+",
	"./shopCode.png": "yyEV",
	"./shopHeaderBg1080.png": "VZrA",
	"./shopHeaderBg2560.png": "kYiD",
	"./shopHeaderBj.png": "GWcj",
	"./shopIntr/issue/bangzhu@2x.png": "26r8",
	"./shopIntr/issue/dianpuHeight@2x.png": "kXb8",
	"./shopIntr/issue/gonggao@2x.png": "7gWq",
	"./shopIntr/issue/huodong@2x.png": "ZmGK",
	"./shopIntr/issue/huodongHeight@2x.png": "xt+a",
	"./shopIntr/issue/kefu@2x.png": "AFxL",
	"./shopIntr/issue/peixun@2x.png": "9XFx",
	"./shopIntr/issue/remen@2x.png": "FeXc",
	"./shopIntr/issue/ruzhu@2x.png": "Cu3J",
	"./shopIntr/issue/ruzhuHeight@2x.png": "J59r",
	"./shopIntr/issue/weifa@2x.png": "5n8L",
	"./shopIntr/issue/weifaHeight@2x.png": "3tmW",
	"./shopIntr/issue/zhuangxiu@2x.png": "jkse",
	"./shopIntr/shop/2560bgbanner@2x.png": "+Yik",
	"./shopIntr/shop/banner1@2x.png": "EICe",
	"./shopIntr/shop/banner2@2x.png": "BHUc",
	"./shopIntr/shop/bgbanner@2x.png": "+ZqB",
	"./shopIntr/shop/huo@2x.png": "rNRM",
	"./shopIntr/shop/jinrong@2x.png": "5B5o",
	"./shopIntr/shop/kaidian@2x.png": "p8aW",
	"./shopIntr/shop/liuchen@2x.png": "cV9B",
	"./shopIntr/shop/liucheng2.png": "BCAq",
	"./shopIntr/shop/liucheng@2x.png": "mzgY",
	"./shopIntr/shop/logo@2x.png": "6ty8",
	"./shopIntr/shop/menkan@2x.png": "RqU7",
	"./shopIntr/shop/quanyi@2x.png": "/Fs1",
	"./shopIntr/shop/zhouqi@2x.png": "8GcL",
	"./stationery.png": "y5It",
	"./stationery_.png": "rCUp",
	"./success@2x.png": "spbY",
	"./tabsBg.png": "Ckpr",
	"./tabsBg2.png": "LKLv",
	"./talk_phone.png": "+CV8",
	"./talk_wx.png": "7kdF",
	"./tel.png": "+eg0",
	"./title-backImg01.png": "YzgH",
	"./title-backImg02.png": "p1pR",
	"./title-backImg03.png": "QbYr",
	"./title-backImg04.png": "st1K",
	"./title01.png": "9L+V",
	"./title02.png": "PsPR",
	"./title03.png": "Ck4k",
	"./title04.png": "t0re",
	"./title05.png": "fmL3",
	"./title06.png": "A7Fl",
	"./title07.png": "hxWA",
	"./title08.png": "DcDy",
	"./title09.png": "irNq",
	"./title10.png": "Lw3j",
	"./title11.png": "9U7M",
	"./title12.png": "6pG6",
	"./title13.png": "Nmks",
	"./titleSide.png": "6D3c",
	"./tututu@2x.png": "tpSj",
	"./user-info-credit.png": "L3LK",
	"./userCard.png": "GBGA",
	"./user_info_icon01.png": "fcOa",
	"./user_info_icon02.png": "Afpw",
	"./user_info_icon03.png": "eEdn",
	"./user_info_icon04.png": "Scyy",
	"./wangwang.png": "dB1K",
	"./weiXintit.png": "DIp2",
	"./yibian@2x.png": "aCf/",
	"./zhutuikuan.png": "XNvE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 18